import { render, staticRenderFns } from "./UserCoupon.vue?vue&type=template&id=17d8822c&scoped=true&"
import script from "./UserCoupon.vue?vue&type=script&lang=js&"
export * from "./UserCoupon.vue?vue&type=script&lang=js&"
import style0 from "./UserCoupon.vue?vue&type=style&index=0&id=17d8822c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d8822c",
  null
  
)

export default component.exports